// src/components/componentsMap.js

// Standard pages
import EmailConfirmationPendingPage from '../pages/EmailConfirmationPendingPage';
import RoomTypesPage from "../pages/RoomTypesPage";
import RoomQRPage from '../pages/RoomQRPage';
import AdminDashboard from '../pages/AdminDashboard';
import ManageUsers from '../pages/ManageUsers';
import AmenitiesPage from '../pages/AmenitiesPage';
import FacilitiesPage from '../pages/FacilitiesPage';
import ModuleAssignment from '../pages/ModuleAssignment';
import EventsPage from '../pages/EventsPage';
import AddUserPage from '../pages/AddUserPage';
import ProfileSettingsPage from '../pages/ProfileSettingsPage';
import AccountSettingsPage from '../pages/AccountSettingsPage';
import Registration from '../pages/Registration';
import Dashboard from '../pages/Dashboard';
import Settings from '../pages/Settings';
import ResetPassword from '../pages/ResetPassword';
import ForgotPassword from '../pages/ForgotPassword';
import SettingsPage from '../pages/SettingsPage';
import PermissionManager from '../pages/RolePermissionManager';

// Hotel & Booking pages
import HotelProfilePage from '../pages/HotelProfilePage';
import BookingListPage from '../pages/BookingListPage';
import BookingPage from "../pages/BookingPage";
// import BookingDetailPage from '../pages/BookingDetailPage'; // Uncomment if available
import CheckInOutPage from '../pages/CheckInOutPage';
import CheckOut from '../pages/CheckOut';
import ReservationCalendarPage from '../pages/ReservationCalendarPage';
import ReservationGantt from '../pages/ReservationGantt';
import RoomListPage from '../pages/RoomListPage';
import RoomStatusPage from '../pages/RoomStatusPage';
import RoomMaintenancePage from '../pages/RoomMaintenancePage';
import AmenitiesListPage from '../pages/AmenitiesListPage';
import ActivitiesListPage from '../pages/ActivitiesListPage';
import EventsListPage from '../pages/EventsListPage';
import TasksPage from '../pages/TasksPage';
 
import ReportsPage from '../pages/ReportsPage';
import GuestListPage from '../pages/GuestListPage';
import GuestProfilesPage from '../pages/GuestProfilesPage';
import ReservationReportsPage from '../pages/ReservationReportsPage';
import HousekeepingPage from '../pages/HousekeepingPage';
import HousekeepingReportsPage from '../pages/HousekeepingReportsPage';

// Financial report
import FinancialReport from '../pages/FinancialReportsPage';

import BedTypesPage from '../pages/BedTypesPage';
import BookingTypesPage from '../pages/BookingTypesPage';
import RatesPage from '../pages/RatesPage';
import HousekeeperDashboard from '../pages/HousekeeperDashboard';
import FloorPlansPage from '../pages/FloorPlansPage';
import RoomImagesPage from '../pages/RoomImagesPage';
import PromotionsPage from '../pages/PromotionsPage';
import ManageStaffPage from '../pages/ManageStaffPage';
import AddStaffPage from '../pages/AddStaffPage';
import LandingPage from '../pages/LandingPage';
import Login from '../pages/Login';
import Unauthorized from '../pages/Unauthorized';
import KYCVerificationPage from '../pages/KYCVerificationPage';
import SetupHotelPage from '../pages/SetupHotelPage';
import KYCUploadPage from '../pages/KYCUploadPage';
import EmailConfirmation from '../pages/EmailConfirmation';
import ResendConfirmationPage from '../pages/ResendConfirmationPage';
import KycReviewPage from '../pages/KycReviewPage';
import HotelForm from '../pages/HotelForm';

import GuestBillingPage from '../pages/GuestBillingPage';

import AdminLegalDocsPage from "../pages/admin/AdminLegalDocsPage";

// If some components are referenced in your seed but not implemented, you can either create them or comment them out.
// For example, these are commented out because they are missing:
// import RoomAvailabilityPage from '../pages/RoomAvailabilityPage';
// import ContentEditor from '../pages/ContentEditor';
// import BookingDetailPage from '../pages/BookingDetailPage';
// import RoomDetailPage from '../pages/RoomDetailPage';
// import ProfilePage from '../pages/ProfilePage';

// Note: If you intend to have a HotelListPage separate from FacilitiesPage, adjust the import accordingly.
// Here, we are mapping HotelListPage to FacilitiesPage.
import HotelListPage from '../pages/FacilitiesPage';

// Content / Info pages
import AboutUsPage from '../pages/AboutUsPage';
import FeaturesPage from '../pages/FeaturesPage';
import RoomPricePage from '../pages/RoomPricePage';
import ContactUsPage from '../pages/ContactUsPage';
// ------------------------
// Maintenance Components
// ------------------------
import MaintenanceDashboard from '../pages/MaintenanceDashboard';
import MaintenancePage from '../pages/MaintenancePage';
import MaintenanceRequestForm from '../pages/MaintenanceRequestForm';
// **Newly Added Components**
import RestaurantOrderPage from '../pages/RestaurantOrderPage';
import CreateServicePage from '../pages/CreateServicePage';
import SystemLogPage from '../pages/SystemLogPage';
// ------------------------
// **Newly Added AdminRegistrationPage**
// ------------------------
 import CssEditorPage from '../pages/admin/CssEditorPage';

import AdminRegistrationPage from '../pages/AdminRegistrationPage';
import HotelSettings from '../pages/HotelSettings';
//console.log('AdminRegistrationPage type:', typeof AdminRegistrationPage);

const componentsMap = {
  // Booking / Room related modules
  SystemLogPage,
  Dashboard,
  AdminDashboard,
  BookingListPage,
  BookingPage,
  // BookingDetailPage, // Uncomment if available
  CheckInOutPage,
  CheckOut,
  ReservationCalendarPage,
  ReservationGantt,
  ModuleAssignment,
  HousekeeperDashboard,
  HousekeepingPage,
  AmenitiesPage,
  RoomListPage,
  RoomStatusPage,
  RoomTypesPage,
  RoomMaintenancePage,
  AmenitiesListPage,
  ActivitiesListPage,
  EventsListPage,
  EventsPage,
  TasksPage,
 
  ReportsPage,
  GuestListPage,
  GuestProfilesPage,
  ReservationReportsPage,
  HousekeepingReportsPage,
  FinancialReport, // Ensure your seed data matches this naming if using FinancialReport
  BedTypesPage,
  BookingTypesPage,
  RatesPage,
  FloorPlansPage,
  RoomImagesPage,
  PromotionsPage,
  ManageStaffPage,
  AddStaffPage,
  
  // Additional modules from AppRoutes
  EmailConfirmationPendingPage,
  RoomQRPage,
  ManageUsers,
  FacilitiesPage,
  AddUserPage,
  ProfileSettingsPage,
  AccountSettingsPage,
  Registration,
  ResetPassword,
  ForgotPassword,
  SettingsPage,
  Settings,
  HotelProfilePage,
  HotelListPage, // Mapped to FacilitiesPage above
  LandingPage,
  Login,
  Unauthorized,
  KYCVerificationPage,
  SetupHotelPage,
  KYCUploadPage,
  EmailConfirmation,
  ResendConfirmationPage,
  KycReviewPage,
  HotelForm,
  // RoomAvailabilityPage, // Uncomment if available
  // ContentEditor,       // Uncomment if available
  // RoomDetailPage,      // Uncomment if available
  // ProfilePage,         // Uncomment if available
  
  // Content / Info pages
  AboutUsPage,
  FeaturesPage,
  RoomPricePage,
  ContactUsPage,
  GuestBillingPage,

  // ------------------------
  // Maintenance Mappings
  // ------------------------
  MaintenanceDashboard,
  MaintenancePage,
  MaintenanceRequestForm,

 
  AdminRegistrationPage ,

    // ------------------------
  // Newly Added Components
  // ------------------------
  RestaurantOrderPage,
  CreateServicePage,
  CssEditorPage,
    PermissionManager, // Add this line
HotelSettings,
  AdminLegalDocsPage,


};

export default componentsMap;
